.signIn {
  display: flex;
  flex-direction: column;
  width: 100%;

  &.flat {
    .fields {
      padding: 0;
      border: none;
      border-radius: 0;
      background-color: transparent;
    }
  }

  .fields {
    width: 100%;
    padding: 1.5rem 1.625rem;
    border: 0.0625rem solid var(--neutral-200);
    border-radius: 1.8125rem;
    background-color: var(--neutral);

    .input {
      margin-bottom: 1.3125rem;
    }

    .password {
      position: relative;
      margin-bottom: 0.4375rem;

      .input {
        margin-bottom: 0.375rem;

        input {
          padding-right: 2.875rem;
        }
      }

      .passwordReveal {
        position: absolute;
        top: 1.875rem;
        right: 0.25rem;
        width: 2.375rem;
        height: 2.375rem;

        @media (min-width: 769px) {
          width: 2.125rem;
          height: 2.125rem;
        }

        svg {
          width: 1.375rem;
          height: 1.375rem;
          pointer-events: none;

          @media (min-width: 769px) {
            width: 1.25rem;
            height: 1.25rem;
          }
        }
      }
    }

    .error {
      display: flex;
      align-items: center;
      margin: 0.75rem 0 0;

      svg {
        flex: 0 0 auto;
        width: 1.125rem;
        height: 1.125rem;
        margin: 0 0.25rem 0 0;

        @media (min-width: 400px) {
          width: 1.25rem;
          height: 1.25rem;
          margin: 0 0.3125rem 0 0;
        }
      }
    }
  }

  .submit {
    width: 100%;
    height: 3rem;
    margin: 1.625rem 0 0;

    @media (min-width: 400px) {
      height: 3.25rem;
    }
  }
}
